import {Paper, withWidth, Typography, Grid} from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import React, {useState} from 'react';
import './EnrollmentsLineChart.sass';
import {
  FlexibleXYPlot,
  XAxis,
  YAxis,
  VerticalGridLines,
  HorizontalGridLines,
  LineMarkSeries,
  LineMarkSeriesPoint,
  Hint,
} from 'react-vis';
import {DaysToCompleteTurnAroundChartDetailsPayload} from 'Enrollment/models/DaysToCompleteTurnAroundChartDetailsPayload';
import {WithWidthProps} from '@material-ui/core/withWidth';

type EnrollmentDaysToCompleteTurnAroundChartProps = {
  daysToCompleteTurnAroundChartDetails: DaysToCompleteTurnAroundChartDetailsPayload[];
} & WithWidthProps;

const EnrollmentDaysToCompleteTurnAroundChart = (props: EnrollmentDaysToCompleteTurnAroundChartProps) => {
  const [hoveredSection, setHoveredSection] = useState<LineMarkSeriesPoint | null>(null);
  const graphData: any[] = props.daysToCompleteTurnAroundChartDetails!.map(d => ({
    x: `${d.monthName}-${d.year!.toString().substring(2, 4)}`,
    y: d.count,
  }));
  return (
    <Paper className="enrollments-line-chart">
      <div className="enrollments-line-chart__header">
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <h3 id="enrollments-line-chart-days-to-complete-title" className="enrollments-line-chart__header-title">Days To Complete Turn Around Time</h3>
          </Grid>
        </Grid>
      </div>
      <div className="enrollments-line-chart__container">
        <FlexibleXYPlot height={300} xType="ordinal" margin={{left: 50,bottom: 80}}>
          <VerticalGridLines />
          <HorizontalGridLines />
          <XAxis tickLabelAngle={-90}/>
          <YAxis />
          <LineMarkSeries
            curve={'curveMonotoneX'}
            data={graphData}
            onNearestX={graphData => setHoveredSection(graphData)}
            onSeriesMouseOut={() => setHoveredSection(null)}
            lineStyle={{stroke: '#0033A0'}}
            markStyle={{stroke: '#0033A0', fill: '#FFFFFF'}}
          />
          {hoveredSection && (
            <Hint value={hoveredSection}>
              <Tooltip title="Hint">
                <Typography className="enrollments-line-chart__hint">{hoveredSection.y}</Typography>
              </Tooltip>
            </Hint>
          )}
        </FlexibleXYPlot>
      </div>
    </Paper>
  );
};

export default withWidth()(EnrollmentDaysToCompleteTurnAroundChart);
